<template>
  <el-form class="project-info" ref="form" :model="value" size="small" inline>
    <el-form-item
      v-for="(item, index) in formItems"
      :key="index"
      :label="item.label"
      :prop="item.prop"
    >
      <span class="form-val">{{
        item.formatter ? item.formatter(value[item.prop]) : value[item.prop]
      }}</span>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: 'project-info',
  props: {
    value: Object
  },
  data() {
    return {
      formItems: [
        { label: '项目ID：', prop: 'id' },
        { label: '安全密钥：', prop: 'secure_key' },
        { label: '项目名称：', prop: 'name' },
        { label: '域：', prop: 'domain' },
        {
          label: '项目类型：',
          prop: 'type',
          formatter: (value) => {
            return this.$store.state.projectTypes[value] || value
          }
        },
        {
          label: '登录权限校验：',
          prop: 'check_res',
          formatter(value) {
            return value ? '是' : '否'
          }
        },
        {
          label: '用户登录身份验证：',
          prop: 'check_login',
          formatter(value) {
            return value ? '是' : '否'
          }
        },
        {
          label: '使用认证中心菜单：',
          prop: 'use_meuns',
          formatter(value) {
            return value ? '是' : '否'
          }
        },
        { label: '项目描述：', prop: 'descr' }
      ]
    }
  }
}
</script>
<style lang="less">
.project-info {
  display: flex;
  flex-wrap: wrap;
  gap: 6%;
  &.el-form--inline {
    .el-form-item {
      display: flex;
      margin-right: 0;
    }
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 5px;
  }
  .el-form-item {
    width: 45%;
    .el-form-item__label {
      white-space: nowrap;
    }

    .form-val {
      white-space: normal;
    }
  }
}
</style>
